<template>
  <div
    class="listing__row"
    :class="{ 'is-validated': ticket.validatedAt, 'disabled': ticket.status !== 'paid'}"
    role="row"
    tabindex="0"
    @click="goToTicket()"
    @keydown.enter.prevent="goToTicket()"
    @keydown.space.prevent="goToTicket()"
  >
    <div class="listing__cell listing__cell--date listing__cell--shrink" role="cell">
      <div class="trip-time" :title="formatDateTime(ticket.trip.timeToStart, true)">
        {{ formatDateTime(ticket.trip.timeToStart) }}
      </div>
    </div>

    <div class="listing__cell listing__cell--route" role="cell">
      <div class="route">
        <strong>{{ ticket.trip.addressToStart.city.name }} → {{ ticket.trip.addressToEnd.city.name }}</strong>
      </div>
    </div>

    <div class="listing__cell listing__cell--status listing__cell--shrink" role="cell">
      <span class="badge" :class="getBadgeClass()">
        {{ getBadgeLabel() }}
      </span>
    </div>
  </div>
</template>

<script setup>
import { useRouter } from 'vue-router'
import { config } from '@/config/env.js'

const props = defineProps({
  ticket: {
    type: Object,
    required: true
  }
})

const router = useRouter()

function goToTicket(ticket) {
  if (props.ticket.status !== 'paid') return
  window.open(`${config.apiUrl}/ticket/${props.ticket.uuid}/pdf`, '_blank', 'noopener,noreferrer')
}

//function goToTicket() {
//  router.push(`/ticket/${props.ticket.uuid}`)
//}

function formatDateTime(dateString, showFullDate = false) {
  if (!dateString) return '—'

  const date = new Date(dateString)

  if (showFullDate) {
    return date.toLocaleString('fr-FR', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    })
  }

  return date.toLocaleString('fr-FR', {
    hour: '2-digit',
    minute: '2-digit'
  })
}

// Logique simplifiée : un seul badge qui affiche le statut le plus important
function getBadgeClass() {
  // Si validé, c'est le statut prioritaire
  if (props.ticket.validatedAt) {
    return 'badge-validated'
  }

  // Sinon on affiche selon le statut
  const status = (props.ticket.status || '').toLowerCase()
  const map = {
    cancelled: 'badge-cancelled',
    refunded: 'badge-refunded',
    paid: 'badge-paid',
    pending_payment: 'badge-pending-payment'
  }

  return map[status] || 'badge-neutral'
}

function getBadgeLabel() {
  // Si validé, on affiche uniquement "Validé"
  if (props.ticket.validatedAt) {
    return '✓ Validé'
  }

  // Sinon on affiche le statut actuel
  const status = (props.ticket.status || '').toLowerCase()
  const labels = {
    pending_payment: 'En attente',
    paid: 'Payé',
    cancelled: 'Annulé',
    refunded: 'Remboursé'
  }

  return labels[status] || props.ticket.status
}
</script>

<style scoped>
.route {
  font-weight: 600;
  color: var(--color-text-primary);
}

.trip-time {
  font-size: 0.9rem;
  color: var(--color-text-secondary);
}

/* Style pour les tickets validés - juste un indicateur visuel léger */
/* .listing__row.is-validated { */
/*   background: var(--color-success-subtle, rgba(34, 197, 94, 0.05)); */
/* } */

/* La ligne reste cliquable et interactive */
.listing__row:hover {
  background: var(--color-hover, rgba(0, 0, 0, 0.04));
  cursor: pointer;
}

/* .listing__row.is-validated:hover { */
/*   background: var(--color-success-hover, rgba(34, 197, 94, 0.1)); */
/* } */

@media (max-width: 768px) {
  .trip-time {
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
  }

  .listing .listing__cell--date {
    max-width: 6ch;
    cursor: help;
  }
}
</style>
